import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Application } from 'src/app/applications/application/application';
import { RequestedDocuments } from '../../case-management/requested-documents';

@Component({
  selector: 'app-case-multi-view',
  templateUrl: './case-multi-view.component.html',
  styleUrls: ['./case-multi-view.component.scss']
})
export class CaseMultiViewComponent implements AfterViewInit {
  @ViewChild("split", {static: true}) splitRef!: ElementRef<HTMLDivElement>;
  @ViewChild("gutter", {static: true}) gutterRef!: ElementRef<HTMLDivElement>;
  @Input() application!: Application;
  @Input() submittedDocuments!: RequestedDocuments;
  
  private readonly minPct = 15;
  private readonly maxPct = 85;

  constructor(private renderer: Renderer2) { }

  ngAfterViewInit(): void {
    const split  = this.splitRef.nativeElement;
    const gutter = this.gutterRef.nativeElement;

    // One listener. No document events.
    this.renderer.listen(gutter, 'pointerdown', (e: PointerEvent) => {
      gutter.setPointerCapture(e.pointerId);

      const onMove = (evt: PointerEvent) => {
        const rect = split.getBoundingClientRect();
        const x = Math.min(Math.max(evt.clientX - rect.left, 0), rect.width);
        let pct = (x / rect.width) * 100;
        pct = Math.max(this.minPct, Math.min(this.maxPct, pct));
        this.splitRef.nativeElement.style.setProperty("--split", `${pct.toFixed(2)}%`);
      };

      const onUp = (evt: PointerEvent) => {
        gutter.releasePointerCapture(evt.pointerId);
        stopMove();
        stopUp();
      };

      const stopMove = this.renderer.listen(gutter, 'pointermove', onMove);
      const stopUp   = this.renderer.listen(gutter, 'pointerup',   onUp);

      const onLost = () => { stopMove(); stopUp(); gutter.removeEventListener('lostpointercapture', onLost); };
      gutter.addEventListener('lostpointercapture', onLost);

      // initial update so click without moving still sets width
      onMove(e);
    });
  }
}
